import { useEffect, useState } from 'react';
import { readAsText, IError, isError, FileInput, Error } from '../common';
import { isEmpty } from 'rambda';
import { map, tail, split, trim, compact } from 'lodash/fp';
import { left, right, map as emap } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/lib/function';

export function ImportFile({
  title,
  onImport,
}: {
  title: string;
  onImport: (items: string[][]) => void;
}) {
  const [contents, setContents] = useState('');
  const [filename, setFilename] = useState('');
  const [error, setError] = useState('');

  const handle = flow(
    split('\n'),
    map<string, string>(trim),
    compact,
    map<string, string[]>(split('|')),

    map<string[], string[]>(map(trim)),

    tail,
    onImport,
    () => setContents('')
  );

  useEffect(() => {
    flow(
      (a: string) => (isEmpty(a) ? left('') : right(a)),
      emap(handle)
    )(contents);
  }, [contents, onImport, handle]);

  return (
    <>
      <FileInput
        title={title}
        onChange={async e => {
          try {
            const x = await readAsText(e)();
            if (!isError(x)) {
              setFilename(x.filename);
              setContents(x.content);
              setError('');
            }
          } catch (e) {
            setError((e as IError).message);
          }
        }}
        filename={filename}
      />
      {isEmpty(error) ? null : <Error>{error}</Error>}
    </>
  );
}
